/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ProcedureStatus {
  PLANNED = 'Planned',

  AWAITING = 'Awaiting Approval',

  APPROVED = 'Approved',

  PREPARATION = 'Preparation',

  IN_PROGRESS = 'In Progress',

  NOT_DONE = 'Not Done',

  ON_HOLD = 'On Hold',

  STOPPED = 'Stopped',

  COMPLETED = 'Completed',

  ERROR = 'Entered In Error',

  POSTPONED = 'Postponed',

  UNKNOWN = 'Unknown',
}
